import { render, staticRenderFns } from "./SectionPage.vue?vue&type=template&id=f9d5fb94&"
import script from "./SectionPage.vue?vue&type=script&lang=js&"
export * from "./SectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports